<!--Login Page Starts-->
<section id="login">
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-body auth-img">
            <div class="row m-0">
              <div class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center auth-img-bg p-3">
                <img src="../../../../assets/img/dtroy/dtroysunset.jpg" alt="" class="img-fluid" width="400"
                  height="400">
              </div>
              <div class="col-lg-6 col-12 px-4 py-3">
                <h4 class="mb-2 card-title">Iniciar sesión</h4>
                <p>Bienvenido a D-troy logistics, inicia sesión para continuar</p>
                <ngb-alert type="light-danger" class="mb-2" *ngIf="isLoginFailed" (close)="isLoginFailed = false">
                  <p class="mb-0">Error al iniciar sesión</p>
                </ngb-alert>
                <form [formGroup]="loginForm">
                  <div class="form-group">
                    <input type="text" formControlName="email" class="form-control" placeholder="E-mail">
                    <div *ngIf="loginFormSubmitted && (lf.username.invalid || lf.username.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Se necesita el
                      email</div>
                  </div>
                  <div class="form-group">
                    <input type="password" formControlName="password" class="form-control" placeholder="Contraseña"
                      required>
                    <div *ngIf="loginFormSubmitted && (lf.password.invalid || lf.password.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Se necesita la
                      contraseña
                    </div>
                  </div>
                  <div class="d-sm-flex justify-content-between mb-3 font-small-2">
                    <div class="remember-me mb-2 mb-sm-0">
                      <div class="checkbox auth-checkbox">
                        <input type="checkbox" class="form-control" id="rememberMe" formControlName="keepLogin">
                        <label for="rememberMe"><span class="font-small-2 mb-3 font-weight-normal">Mantener sesión
                            abierta</span></label>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between flex-sm-row flex-column">
                    <button class="btn btn-info" (click)="onSubmit()"
                      [disabled]="loginForm.invalid || isLogin">Entrar</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Login Page Ends-->
<ngx-spinner></ngx-spinner>